module.exports = __webpack_public_path__ + "img/emer-contacts.08402e0f.svg";